/**
 * Auto Close Details
 *
 * Automatically closes open <details> elements when the user
 * clicks outside of them.
 *
 * Supported values:
 *
 * data-auto-close-details="mobile"
 * data-auto-close-details="desktop"
 * data-auto-close-details="mobile desktop"
 *
 * Breakpoint:
 * Mobile  < 750px
 * Desktop >= 750px
 */

(function autoCloseDetails() {
  const MOBILE_BREAKPOINT = 750;

  /**
   * Returns the current device context used by Horizon.
   *
   * @returns {'mobile' | 'desktop'}
   */
  function getCurrentBreakpoint() {
    return window.innerWidth < MOBILE_BREAKPOINT
      ? 'mobile'
      : 'desktop';
  }

  /**
   * Determines whether a details element should automatically
   * close at the current breakpoint.
   *
   * @param {HTMLDetailsElement} details
   * @param {'mobile' | 'desktop'} breakpoint
   * @returns {boolean}
   */
  function shouldAutoClose(details, breakpoint) {
    const value = details
      .getAttribute('data-auto-close-details')
      ?.toLowerCase()
      .trim();

    if (!value) return false;

    const breakpoints = value.split(/\s+/);

    return breakpoints.includes(breakpoint);
  }

  /**
   * Checks whether the click happened inside the details element.
   *
   * composedPath() also handles clicks originating from
   * nested Shadow DOM more reliably than contains() alone.
   *
   * @param {Event} event
   * @param {HTMLDetailsElement} details
   * @returns {boolean}
   */
  function clickedInside(event, details) {
    if (typeof event.composedPath === 'function') {
      return event.composedPath().includes(details);
    }

    return (
      event.target instanceof Node &&
      details.contains(event.target)
    );
  }

  /**
   * Handles document clicks.
   *
   * @param {MouseEvent} event
   */
  function handleDocumentClick(event) {
    const breakpoint = getCurrentBreakpoint();

    const openDetails = document.querySelectorAll(
      'details[data-auto-close-details][open]'
    );

    for (const element of openDetails) {
      if (!(element instanceof HTMLDetailsElement)) continue;

      if (!shouldAutoClose(element, breakpoint)) continue;

      if (clickedInside(event, element)) continue;

      element.open = false;
    }
  }

  document.addEventListener('click', handleDocumentClick);
})();